import PropTypes from 'prop-types';

const StylePropType = PropTypes.oneOfType([
  // An inline style
  // <View style={{ borderRight: 1 }} />
  PropTypes.object,
  // Stylesheet.create() creates styles represented by numbers for performance.
  // {
  //   myStyle1: 225,
  //   myStyle2: 43,
  // }
  // <View style={styles.myStyle1} />
  PropTypes.number,
  // An array of styles
  // <View style={[styles.myStyle1, styles.myStyle2]} />
  PropTypes.array,
]);

export default StylePropType;
